import React, { useEffect, useState } from "react";
import localforage from "localforage";
import Dashboard from "./Dashboard";

/**
 * Leadership Dashboards hub - one page per project.
 *
 *   /leadership-dashboards      -> Punjab
 *   /leadership-dashboards-ap   -> Andhra Pradesh
 *
 * ACCESS: this page keeps no allow-list of its own. The API
 * (routes/dashboards.js) is the single source of truth; a dashboard the user
 * may not open simply reports "Not authorised". A second copy of the list here
 * previously caused real access bugs.
 *
 * To add a dashboard: add a card below. Externally hosted ones also need one
 * entry in EMBEDS in routes/dashboards.js and use href /dashboard-embed/<key>.
 */

const PROJECTS = {
  punjab: {
    title: "Leadership Dashboards — Punjab",
    cards: [
      {
        href: "/dashboard-caste-census",
        title: "Caste Census Digitalisation",
        desc: "Daily digitalisation progress by zone, district and AC.",
      },
      {
        href: "/dashboard-interventions",
        title: "Region Wise Interventions",
        desc: "AC leadership tracking, field intelligence and political actionables.",
      },
      {
        href: "/dashboard-alliance",
        title: "Alliance & Party Wise Performance",
        desc: "Punjab alliance change and impact analysis.",
      },
      {
        href: "/dashboard-embed/polling-station-atlas",
        title: "Punjab Polling Station Atlas",
        desc: "Polling-station level map and booth intelligence across Punjab.",
      },
      {
        href: "/dashboard-embed/campaign-route-atlas",
        title: "Campaign Route Atlas",
        desc: "Campaign route planning and coverage across constituencies.",
      },
    ],
  },
  ap: {
    title: "Leadership Dashboards — Andhra Pradesh",
    cards: [
      {
        href: "/ap-proformas",
        title: "Assembly Constituency Proformas",
        desc: "AC-level dossier: profile, electoral history, caste, leadership, booths and risks.",
        // Shown only to these people; the API enforces the same list.
        onlyFor: [
          "pardhasaradhi@showtimeconsulting.in", "rs@showtimeconsulting.in", "at@showtimeconsulting.in",
          "khushboo@showtimeconsulting.in", "alimpan@showtimeconsulting.in", "aditya.pandit@showtimeconsulting.in",
        ],
      },
      {
        href: "/dashboard-embed/ap-electoral-mapping",
        title: "Andhra Pradesh Electoral Mapping Dashboard – Post SIR 2026",
        desc: "Electoral and voter mapping across Andhra Pradesh after the Special Intensive Revision.",
      },
    ],
  },
};

const DirectorDashboards = ({ project = "punjab" }) => {
  const [email, setEmail] = useState("");
  const cfg = PROJECTS[project] || PROJECTS.punjab;

  useEffect(() => {
    localforage.getItem("email").then((e) => setEmail(e || ""));
  }, []);

  return (
    <div>
      <Dashboard />
      <div style={{ padding: "20px", maxWidth: "1100px", margin: "0 auto" }}>
        <h2 style={{ textAlign: "center", marginBottom: "4px" }}>{cfg.title}</h2>
        {email ? (
          <p style={{ textAlign: "center", color: "#8a97a7", fontSize: "12.5px", marginTop: 0 }}>
            Signed in as {email}
          </p>
        ) : null}

        <div style={{
          display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "14px", marginTop: "16px",
        }}>
          {cfg.cards.filter((d) => !d.onlyFor || d.onlyFor.includes(String(email || "").trim().toLowerCase())).map((d) => (
            <a key={d.href} href={d.href}
              style={{
                display: "block", textDecoration: "none", color: "inherit", background: "#fff",
                border: "1px solid #dbe5f0", borderRadius: "12px", padding: "18px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)", cursor: "pointer",
              }}>
              <div style={{ fontWeight: 800, color: "#0f3b6b", fontSize: "16px", marginBottom: "6px" }}>
                {d.title}
              </div>
              <div style={{ fontSize: "13px", color: "#5b6b7f" }}>{d.desc}</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DirectorDashboards;
